import React, { useState } from 'react'
import { Link } from 'react-scroll';
function HeaderRight({ onClick }) {
    const [activeSection, setActiveSection] = useState('home');
    const handleSetActive = (to) => {
        setActiveSection(to);
    };
    const sections = [
        { to: "home", label: "Home" },
        { to: "about", label: "About Us" },
        { to: "feature", label: "Features" },
        { to: "token", label: "UWPS Token" },
        { to: "card", label: "Crypto Card" },
        { to: "roadmap", label: "Roadmap" },
        { to: "faq", label: "FAQs" },
        { to: "contact", label: "Contact" },
    ];
    return (
        <>
            {sections.map((section) => (
                <Link onClick={onClick}
                    key={section.to}
                    to={section.to}
                    spy={true}
                    smooth={true}
                    duration={500}
                    onSetActive={handleSetActive}
                    className={activeSection === section.to ? "active" : ""}
                >
                    {section.label}
                </Link>
            ))}
        </>
    );
}

export default HeaderRight;
